import { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            await api.post("/contact", form);
            setSent(true);
            track("contact_form_submitted");
            toast.success("Message sent. We'll be in touch.");
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail));
        } finally { setSending(false); }
    };

    return (
        <div className="ok-container py-12 max-w-lg mx-auto" data-testid="contact-page">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--ok-accent)]">Get in touch</div>
            <h1 className="font-display text-3xl sm:text-4xl mt-2">Contact UNVEILED</h1>
            <p className="opacity-70 mt-2 text-sm leading-relaxed">
                Submit research, tips, press enquiries, partnership requests, or general feedback.
                We read every message.
            </p>

            {sent ? (
                <div className="ok-card p-8 mt-8 text-center" data-testid="contact-sent">
                    <CheckCircle2 className="w-12 h-12 mx-auto text-[var(--ok-accent)]" />
                    <h2 className="font-display text-xl mt-4">Message received</h2>
                    <p className="text-sm opacity-70 mt-2">Thank you. We'll respond by email within a few days.</p>
                </div>
            ) : (
                <form onSubmit={submit} className="ok-card p-7 mt-8 space-y-4" data-testid="contact-form">
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Your name</label>
                        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="ok-input" data-testid="contact-name" />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Email</label>
                        <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="ok-input" data-testid="contact-email" />
                    </div>
                    <div>
                        <label className="font-mono text-[10px] uppercase tracking-widest opacity-60 block mb-1.5">Message</label>
                        <textarea required rows={6} minLength={10} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="ok-input" data-testid="contact-message" />
                    </div>
                    <button type="submit" disabled={sending} className="ok-btn-primary w-full justify-center" data-testid="contact-submit">
                        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
                        Send message
                    </button>
                    <p className="text-[11px] opacity-50 text-center">
                        We'll respond to your email. Your address is never published.
                    </p>
                </form>
            )}
        </div>
    );
}
